import { render, staticRenderFns } from "./CleanDataModal.vue?vue&type=template&id=037494ed&scoped=true"
import script from "./CleanDataModal.vue?vue&type=script&lang=js"
export * from "./CleanDataModal.vue?vue&type=script&lang=js"
import style0 from "./CleanDataModal.vue?vue&type=style&index=0&id=037494ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037494ed",
  null
  
)

export default component.exports